import { definePersistentQueryParamStore } from '@warehouse/shared/util';
import { StateCreator } from 'zustand/vanilla';

export interface SearchStore {
	searchValue: string;
	actions: {
		setSearchValue: (value: string) => void;
	};
}

export const createSearchSlice: StateCreator<SearchStore> = (set) => ({
	searchValue: '',
	actions: {
		setSearchValue: (value: string) => set(() => ({ searchValue: value })),
	},
});

export const [SearchProvider, useSearchStore] = definePersistentQueryParamStore<SearchStore>(createSearchSlice);

export const searchStoreSelector = {
	actions: (state: SearchStore) => state.actions,
	searchValue: (state: SearchStore) => state.searchValue,
};
